export interface PaymentEventData {
  IsFinancePlanSetup: boolean;
  IsRegisteredUser: boolean;
  AmountPaid: number;
  FinancePlanMonthlyPaymentAmount: number;
}

export const getPaymentType = (eventData: PaymentEventData) => {
  if (eventData?.IsFinancePlanSetup === true && eventData?.IsRegisteredUser === true) {
    return 'finance plan';
  }

  if (eventData?.IsFinancePlanSetup === false && eventData?.IsRegisteredUser === true) {
    return 'bill pay';
  }

  if (eventData?.IsRegisteredUser === false) {
    return 'guest bill pay';
  }
  return '';
};
